import React from "react";
import { processSteps } from "../data/mockData";
import { BookOpen, ArrowLeftRight, CheckCircle, ArrowRight } from "lucide-react";

const iconMap = {
  BookOpen: BookOpen,
  ArrowLeftRight: ArrowLeftRight,
  CheckCircle: CheckCircle,
};

const Process = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm font-semibold text-[#3A7D44] uppercase tracking-wider">
            How It Works
          </span>
          <h2
            className="text-3xl sm:text-4xl font-bold text-[#1B2A1B] mt-3 mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Simple. Clear. Your Way.
          </h2>
          <p className="text-[#5A6B5A] leading-relaxed">
            Finding the right insurance doesn't have to be complicated. Here's
            how we work together.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute top-24 left-[20%] right-[20%] h-0.5 bg-[#E8F5E9]" />

          {processSteps.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div key={item.step} className="relative text-center">
                {/* Step number */}
                <div className="relative z-10 mx-auto w-16 h-16 bg-[#3A7D44] rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-[#3A7D44]/20">
                  {IconComponent && (
                    <IconComponent size={28} className="text-white" />
                  )}
                </div>

                {/* Step indicator */}
                <div className="inline-flex items-center justify-center w-8 h-8 bg-[#E8F5E9] rounded-full text-sm font-bold text-[#3A7D44] mb-4">
                  {item.step}
                </div>

                <h3 className="text-xl font-bold text-[#1B2A1B] mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-[#5A6B5A] leading-relaxed max-w-xs mx-auto">
                  {item.description}
                </p>

                {/* Arrow between steps (desktop) */}
                {item.step < processSteps.length && (
                  <div className="hidden md:block absolute top-24 -right-4 z-20">
                    <ArrowRight size={20} className="text-[#3A7D44]" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
